/* eslint-disable no-underscore-dangle */
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { EventsService } from 'src/app/services/events.service';
import { EventVM } from 'src/app/models/event/event';
import { StorageService } from 'src/app/services/util/storage.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
declare var jQuery: any;
declare var SIR: any;
@Component({
  selector: 'app-streaming-widget',
  templateUrl: './streaming-widget.component.html',
  styleUrls: ['./streaming-widget.component.less']
})
export class StreamingWidgetComponent implements OnInit, AfterViewInit {
  private language: string;
  expandEvent: EventVM = null;
  private _betRadarEventId: number;
  private widgetLanguage: string;
  isMobileView: boolean;
  widgetType: string;
  widgetType1: string;
  detailedScoreboard: string;
  tabsPosition: string;

  clientId = '92628c1eaee83871af5e17444ec08c99';

  layout = 'single';
  // layout = 'double';
  collapseTo: string;

  showWidget = false;

  viewConfigurations = ViewConfigurations;

  @Input()
  isFullSize: boolean;

  @Input('betRadarEventId')
  set betRadarEventId(value: number) {
    if (this._betRadarEventId !== undefined) {
      this._betRadarEventId = value;
      this.setMatchIdOnWidget();
    } else {
      this._betRadarEventId = value;
    }
  }

  constructor(private storageService: StorageService, private utilityService: UtilityService, private eventsService: EventsService) {
    // this.language = this.storageService.language;
    this.isMobileView = utilityService.mobileView;
  }

  ngOnInit(): void {

    // this.widgetLanguage = LocaleHelper.languageForBetradar[this.language];


    if (this.isFullSize) {
      this.collapseTo = 'momentum';
    } else {
      this.collapseTo = 'disable';
    }

    if (this.isMobileView) {
      this.layout = 'single';
      this.widgetType = 'lmtPlus';
      this.widgetType1 = 'lmtSticky';
      this.collapseTo = 'disable';
      this.tabsPosition = 'top';
      this.detailedScoreboard = 'disable';
    } else {
      this.layout = this.viewConfigurations.widgetLayoutDouble ? 'double' : 'single';
      this.widgetType = 'lmtPlus';
      this.tabsPosition = 'bottom';
      this.detailedScoreboard = 'enable';
    }

    // // tslint:disable:no-string-literal
    // if (!window['SIR']) {
    //   // console.log('widget initialized');
    //   ((a, b, c, d, e, f, g, h, i) => {
    //     // tslint:disable-next-line:no-unused-expression
    //     a[e] || (i = a[e] = () => { (a[e].q = a[e].q || []).push(arguments); },
    //       i.l = 1 * (Number)(new Date()),
    //       i.o = f,
    //       g = b.createElement(c),
    //       h = b.getElementsByTagName(c)[0],
    //       g.async = 1,
    //       g.src = d,
    //       g.setAttribute('n', e),
    //       h.parentNode.insertBefore(g, h)
    //     );
    //   })(window, document, 'script', 'https://widgets.sir.sportradar.com/' + this.clientId + '/widgetloader', 'SIR', {
    //     theme: false, // using custom theme
    //     language: this.widgetLanguage
    //   });

    // }

    this.setMatchIdOnWidget();

    if (this.isMobileView) {
      this.setMatchIdOnStickyWidget();
    }

  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   // console.log('kreno');
    //   const interval = setInterval(() => { this.setWidget(interval); }, 300);
    // }, 500);
  }

  setWidget(interval) {
    this.setMatchIdOnWidget();

    if (this.isMobileView) {
      this.setMatchIdOnStickyWidget();
    }
    // if (document.querySelector('.lmt-container')) {


    //   if (document.querySelector('.lmt-container .srm-fullyloaded')) {
    //     clearInterval(interval);
    //   }
    // }
  }


  // changeLanguage() {
  //   if (window['SRLive']['languages']) {
  //     window['SRLive']['languages']['change'](this.widgetLanguage);
  //   }
  // }

  setMatchIdOnWidget() {
    // console.log(this._betRadarEventId);
    if (this._betRadarEventId) {
      this.showWidget = true;

      setTimeout(() => {
        SIR('addWidget', '.lmt-container', 'match.' + this.widgetType, {
          collapseTo: this.collapseTo,
          layout: this.layout,
          detailedScoreboard: this.detailedScoreboard,
          tabsPosition: this.tabsPosition,
          matchId: this._betRadarEventId
        });

        setTimeout(() => {
          if (jQuery('.sr-error__message').text() === '') {
            this.eventsService.widgetError(false);
          } else {
            this.eventsService.widgetError(true);
          }
        }, 200);
      }, 100);

    }
  }
  setMatchIdOnStickyWidget() {
    // console.log(this._betRadarEventId);
    SIR('addWidget', '.lmt-container-sticky', 'match.' + this.widgetType1, {
      collapseTo: this.collapseTo,
      layout: this.layout,
      matchId: this._betRadarEventId
    });
  }

  onDestroy() {
    SIR('removeWidget', document.querySelector('.sr-widget'));
    SIR('check');
  }

}
